var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    d: "m14.059 12.465 4.828-4.781.984-.985c.14-.14.14-.375 0-.562L18.84 5.105c-.188-.14-.422-.14-.563 0l-5.765 5.813-5.813-5.813c-.14-.14-.375-.14-.562 0L5.105 6.137c-.14.187-.14.422 0 .562l5.813 5.766-5.813 5.812c-.14.141-.14.375 0 .563l1.032 1.031c.187.14.422.14.562 0l5.813-5.812 4.781 4.828.984.984c.141.14.375.14.563 0l1.031-1.031c.14-.188.14-.422 0-.563z"
  })));
};
export default SvgClose;